import React from "react";

// Long-haired woman → adult
const WomanIcon = ({ size = 16, className = "", strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="7" r="3.1" />
    <path d="M8.7 6.2C7.9 9 7.6 12.5 8 15.5" />
    <path d="M15.3 6.2C16.1 9 16.4 12.5 16 15.5" />
    <path d="M6.5 20c.4-3.3 2.3-4.8 5.5-4.8s5.1 1.5 5.5 4.8" />
  </svg>
);

// Pigtail girl → children
const GirlIcon = ({ size = 16, className = "", strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="8.5" r="3" />
    <circle cx="7.4" cy="8" r="1.7" />
    <circle cx="16.6" cy="8" r="1.7" />
    <path d="M7 20.5c.4-3 2.1-4.4 5-4.4s4.6 1.4 5 4.4" />
  </svg>
);

// Two people together → together
const DuoIcon = ({ size = 16, className = "", strokeWidth = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="8.4" cy="8" r="2.5" />
    <circle cx="15.6" cy="8" r="2.5" />
    <path d="M3.8 19c.4-3 1.9-4.4 4.6-4.4 1.4 0 2.5.4 3.3 1.3" />
    <path d="M12.3 15.9c.8-.9 1.9-1.3 3.3-1.3 2.7 0 4.2 1.4 4.6 4.4" />
  </svg>
);

const MAP = {
  adult: { Icon: WomanIcon, label: "Felnőtt" },
  children: { Icon: GirlIcon, label: "Gyerek" },
  together: { Icon: DuoIcon, label: "Közös" },
};

export const AUDIENCE_LABEL = { adult: "Felnőtt", children: "Gyerek", together: "Közös" };

export const AudienceIcon = ({ audience, size = 16, className = "", strokeWidth = 1.6 }) => {
  const entry = MAP[audience] || MAP.adult;
  const Icon = entry.Icon;
  return <Icon size={size} className={className} strokeWidth={strokeWidth} />;
};

export const AudienceBadge = ({ audience, size = 14, className = "" }) => {
  const entry = MAP[audience] || MAP.adult;
  const Icon = entry.Icon;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-white/70 border border-black/5 px-2.5 py-1 text-[11px] font-semibold text-ink ${className}`} data-testid="audience-badge">
      <Icon size={size} strokeWidth={1.7} /> {entry.label}
    </span>
  );
};
